<template>
  <div class="container">
    <div class="left-panel">
      <div><img :src="image" :alt="title" width="250px"/></div>
    </div>
    <div class="right-panel">
      <div><h3>{{ title }}</h3></div>
      <p><strong>{{ subtitle }}</strong></p>
      <div><p class="content">{{ content }}</p></div>
      <div class="button">
        <el-button type="primary" @click="sendMailProduit(title)" class="buttonBlockProduit">{{$t('dashboard.beCall') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { sendEmail } from '@/services/email'
import { mapGetters } from 'vuex'

export default {
  name: 'CardProduct',
  props: {
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(['getSitimmoUser'])
  },
  methods: {
    async sendMailProduit (produit) {
      const logo = processEnvConfig.VUE_APP_IMAGE_FILIGRANE_MAIL
      const element = '<div style="width: 700px; margin: auto;"> <div style="background-color: #255662; height: 140px; width: 700px; margin-bottom: 50px"> <img style="width: 350px; margin-top: 6%; margin-left: 29%" src="' + logo + '"> </div> <p style="font-family: Dosis, Arial, Helvetica, sans-serif; font-size: 17px;text-align: center;">L\'' + this.$store.state.app.sitimmoUser.login + ' souhaite être recontacté pour en savoir plus sur le produit : ' + produit + '</p> </div>'
      const sendTo = processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_MARKETING
      // sendTo.push({email: "jennifer.oberle@ubiflow.net"});
      const mailData = {
        to: sendTo,
        subject: 'Demande d’information sur le produit : ' + produit + ' - ' + this.getSitimmoUser.login,
        content: element
      }
      const repEnvoiMail = await sendEmail(mailData)
      if (repEnvoiMail.type === 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
      } else {
        this.$message({ message: this.$t('dashboard.emailSend'), type: 'success' })
      }
    }
  }
}
</script>
<style scoped>
.container {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 350px;
  margin: 0 auto;
}

.left-panel {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.right-panel {
  flex: 1;
  background-color: #fff;
  padding: 0 20px;
  position: relative;
}

.button{
  display: flex;
  align-self: end;
}

/* Styles responsive */
@media (max-width: 768px) {
  .container {
    flex-direction: column;
    height: auto;
  }

  .left-panel, .right-panel {
    width: 100%;
    height: 300px;
  }

  .right-panel {
    height: auto;
    padding: 15px;
  }

  .button {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .right-panel {
    padding: 10px;
  }
}
</style>
